import { makeDataStore } from '../y/data-store';
import { YId, YCountryId } from '../y/types';

export interface UCoordinates {
    lat: number;
    lng: number;
}

export interface CCity {
    id: YId;
    name: string;
    country: YCountryId;
    slug: string;
    location: UCoordinates;
    can_signup: boolean;
}

export const c_cities = makeDataStore('new_cities', 'city', (m: CCity) => m, Object.assign);

export function cCityBySlug(slug: string) {
    return c_cities.all.find(c => c.slug == slug);
}
